import React, { useRef, useState } from "react";
import { uploadAdminDocument } from '../api/admin_document_api';
import AdminDocument from './AdminDocument';
import { useNavigate } from 'react-router-dom';


const DocumentsImportant = () => {
    const fileInputRef = useRef(null);
    const navigate = useNavigate();
    const [refreshTrigger, setRefreshTrigger] = useState(false);
    const handleFileUpload = async (e) => {
        const file = e.target.files[0]; // ודאי שזה אכן הקובץ
        if (!file) return;

        try {
            const originalName = file.name;
            // כאן אנחנו קוראים לפונקציה מה-API
            await uploadAdminDocument(file, originalName);

            alert('המסמך הועלה בהצלחה');
            setRefreshTrigger(prev => !prev);
        } catch (err) {
            console.error("Upload error:", err);
            alert('אירעה שגיאה בהעלאת המסמך');
        }
    };

    return (

        <>
            <div className="top-buttons-container" style={{ marginBottom: "1.25rem" }}>
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <div className="beneficiaries-container" style={{ marginTop: "4rem" }}>
                {/* כותרת */}
                <div className='header' style={{ display: 'flex', alignItems: 'baseline', gap: '24px', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span className="dot"></span>
                        <h1 className="title">ניהול מסמכי מערכת</h1>
                        <span className="dot"></span>
                    </div>
                    <div className="upload-section">
                        <input
                            type="file"
                            id="file-upload"
                            style={{ display: 'none' }}
                            onChange={handleFileUpload}
                        />
                        <label htmlFor="file-upload" className="upload-label" style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: 0 }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" />
                                <line x1="12" y1="8" x2="12" y2="16" />
                                <line x1="8" y1="12" x2="16" y2="12" />
                            </svg>
                            <span className="upload-text">העלאת מסמך</span>
                        </label>
                    </div>
                </div>

                {/* הצגת הטבלה החדשה */}
                <div className="table-wrapper">
                    <AdminDocument
                        refreshTrigger={refreshTrigger}
                    />
                </div>
            </div>
        </>
    );
};

export default DocumentsImportant;